/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdf_Cv_Review_Category_RelevanceInputs */

const en_pdf_cv_review_category_relevance = /** @type {(inputs: Pdf_Cv_Review_Category_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relevance`)
};

const de_pdf_cv_review_category_relevance = /** @type {(inputs: Pdf_Cv_Review_Category_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relevanz`)
};

/**
* | output |
* | --- |
* | "Relevance" |
*
* @param {Pdf_Cv_Review_Category_RelevanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pdf_cv_review_category_relevance = /** @type {((inputs?: Pdf_Cv_Review_Category_RelevanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdf_Cv_Review_Category_RelevanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pdf_cv_review_category_relevance(inputs)
	return en_pdf_cv_review_category_relevance(inputs)
});